/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getProfile} from '../api'

 export const useQueryGetProfile = createReactQueryHook('getProfile', getProfile)
